module.exports = __webpack_public_path__ + "img/logo-min.d34f4e60.png";